// Yield percentages (as decimals) per product.
// Products not listed here default to DEFAULT_YIELD (93%).
export const DEFAULT_YIELD = 0.93;

export const PRODUCT_YIELD = {
  AMT:   0.93,
  ATR:   0.96,
  BUP:   0.94,
  CYC:   0.93,
  CZX:   0.87,
  ESC:   0.95,
  ESO:   0.92,
  FAMO:  0.86,
  FURO:  0.93,
  GBC:   0.97,
  GBT:   0.96,
  HYH:   0.94,
  LVT:   0.95,
  MNT:   0.95,
  PANTO: 0.92,
  TRAZ:  0.94,
  TRAM:  0.95,
};
